<template>
  <div class="survey-container">
    <form @submit.prevent="showConfirm" novalidate>
      <fieldset :disabled="response_date">
        <div class="survey-question">
          <label class="question-text">
            組織コードまたは紹介者コードを持っていますか？
            <span class="required">(必須)</span>
          </label>
          <div class="radio-options">
            <input type="radio" value="none" v-model="codeType" required />
            <label class="radio-label">持っていない</label>
          </div>
          <div class="radio-options">
            <input type="radio" value="org" v-model="codeType" required />
            <label class="radio-label">組織コードあり</label>
          </div>
          <div class="radio-options">
            <input type="radio" value="referral" v-model="codeType" required />
            <label class="radio-label">紹介者コードあり</label>
          </div>
          <div v-if="codeType">
            <div v-if="codeType === 'referral'">
              <label class="question-text">
                紹介者コード
                <span class="required">(必須)</span>
              </label>
              <input
                type="text"
                class="form-control"
                v-model="profile.referred_by_code"
                required
              />
              <span class="error-message" v-if="referredByCodeError">
                {{ referredByCodeError }}
              </span>
            </div>
            <div v-if="codeType === 'org'">
              <label class="question-text">
                組織コード
                <span class="required">(必須)</span>
              </label>
              <input
                type="text"
                class="form-control"
                v-model="profile.organization_code"
                required
              />
              <span class="error-message" v-if="organizationCodeError">
                {{ organizationCodeError }}
              </span>
            </div>
          </div>
        </div>
        <div v-if="codeType">
          <hr />
          <div class="survey-question" v-if="codeType !== 'org'">
            <label class="question-text">
              組織名（企業・団体名、学校名）
              <span>(任意)</span>
            </label>
            <input
              type="text"
              class="form-control"
              v-model="profile.organization_name"
              required
            />
            <span class="error-message" v-if="organizationError">
              {{ organizationError }}
            </span>
          </div>
          <div class="survey-question">
            <label class="question-text">
              姓
              <span>
                (任意)
                <span style="font-weight: normal;">
                  ※修了証を発行する場合に使用します。
                </span>
              </span>
            </label>
            <input
              type="text"
              class="form-control"
              v-model="profile.last_name"
            />
            <span class="error-message" v-if="lastNameError">
              {{ lastNameError }}
            </span>
          </div>
          <div class="survey-question">
            <label class="question-text">
              名
              <span>
                (任意)
                <span style="font-weight: normal;">
                  ※修了証を発行する場合に使用します。
                </span>
              </span>
            </label>
            <input
              type="text"
              class="form-control"
              v-model="profile.first_name"
            />
            <span class="error-message" v-if="firstNameError">
              {{ firstNameError }}
            </span>
          </div>
          <hr />
          <!--DBで管理しているアンケート項目-->
          <div
            class="survey-question"
            v-for="(question, index) in filteredQuestions"
            :key="question.id"
          >
            <label class="question-text">
              {{ index + 1 }}. {{ question.text }}
              <span v-if="question.required" class="required">(必須)</span>
              <span v-else>(任意)</span>
            </label>
            <div v-if="question.question_type === 'input'">
              <input
                type="text"
                class="form-control"
                v-model="responses[question.id]"
                :required="question.required"
              />
            </div>
            <div v-else-if="question.question_type === 'textarea'">
              <textarea
                class="form-control"
                v-model="responses[question.id]"
                :required="question.required"
              ></textarea>
            </div>
            <div v-else-if="question.question_type === 'select'">
              <select
                class="form-control"
                v-model="responses[question.id]"
                :required="question.required"
              >
                <option
                  v-for="choice in question.choices"
                  :key="choice.id"
                  :value="choice.id"
                >
                  {{ choice.text }}
                </option>
              </select>
            </div>
            <div v-else-if="question.question_type === 'checkbox'">
              <div
                class="checkbox-options"
                v-for="choice in question.choices"
                :key="choice.id"
              >
                <input
                  type="checkbox"
                  :value="choice.id"
                  v-model="responses[question.id]"
                />
                <label class="checkbox-label">{{ choice.text }}</label>
              </div>
            </div>
            <div v-else-if="question.question_type === 'radio'">
              <div
                class="radio-options"
                v-for="choice in question.choices"
                :key="choice.id"
              >
                <input
                  type="radio"
                  :value="choice.id"
                  v-model="responses[question.id]"
                  :name="`radio-${question.id}`"
                  :required="question.required"
                />
                <label class="radio-label">{{ choice.text }}</label>
              </div>
            </div>
            <span class="error-message" v-if="question.errorMessage">
              {{ question.errorMessage }}
            </span>
          </div>
          <button
            class="btn"
            :class="{
              'btn-disabled': response_date,
              'btn-submit': !response_date
            }"
            type="submit"
          >
            {{ response_date ? "回答済み" : "回答を送信する" }}
          </button>
        </div>
      </fieldset>
    </form>
    <div v-if="response_date">
      回答日時: {{ response_date | formatDateTime }}
    </div>
    <div v-if="error" class="error-message">
      エラーが発生しました。
    </div>
    <div v-if="validateError" class="error-message">
      入力内容を確認してください。
    </div>
    <!-- 送信確認 -->
    <modal name="confirm" adaptive height="auto" width="85%" :maxWidth="789">
      <section id="confirm" class="c_popup">
        <h2 class="c_popup_ttl">確認</h2>
        <div v-if="!loading && !submitted && !error">
          <p class="c_popup_lead">
            送信してもよろしいですか？
            <br />
            <span style="font-weight: bold;color: red;">
              送信後は回答内容の変更ができません。
            </span>
          </p>
          <div class="c_popup_btns">
            <button class="c_btn" type="button" @click="submitResponses">
              回答を送信
            </button>
            <button
              class="c_btn -gray"
              type="button"
              @click="$modal.hide('confirm')"
            >
              キャンセル
            </button>
          </div>
        </div>
        <div v-else-if="loading" class="c_load"></div>
        <div v-else-if="error">
          <p class="c_popup_lead">
            <span style="font-weight: bold;color: red;">
              エラーが発生しました。
            </span>
          </p>
          <div class="c_popup_btns">
            <button
              class="c_btn -gray"
              type="button"
              @click="$modal.hide('confirm')"
            >
              閉じる
            </button>
          </div>
        </div>
        <div v-else-if="submitted">
          <p class="c_popup_lead">
            ご回答ありがとうございました！
          </p>
          <div class="c_popup_btns">
            <button
              class="c_btn"
              type="button"
              @click="$router.push({ name: 'Home' })"
            >
              トップに戻る
            </button>
          </div>
        </div>
      </section>
    </modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      questions: [],
      localQuestions: {},
      responses: {},
      response_date: null,
      error: false,
      validateError: false,
      profile: {
        organization_name: "",
        last_name: "",
        first_name: "",
        referred_by_code: "",
        organization_code: ""
      },
      organizationError: "",
      referredByCodeError: "",
      organizationCodeError: "",
      lastNameError: "",
      firstNameError: "",
      loading: false,
      submitted: false,
      codeType: "" // "none" | "referral" | "org"
    };
  },
  watch: {
    codeType: {
      handler() {
        if (!this.response_date) {
          this.error = false;
          this.validateError = false;
          this.organizationError = "";
          this.referredByCodeError = "";
          this.organizationCodeError = "";
          this.lastNameError = "";
          this.firstNameError = "";
          this.profile.referred_by_code = "";
          this.profile.organization_code = "";
          this.questions.forEach(q => {
            q.errorMessage = "";
          });
        }
      }
    }
  },
  methods: {
    async showConfirm() {
      this.error = false;
      this.validateError = false;
      const isValid = await this.validateForm();
      if (isValid) {
        this.$modal.show("confirm");
      } else {
        this.validateError = true;
      }
    },
    async submitResponses() {
      this.error = false;
      this.validateError = false;
      if (this.validateForm()) {
        this.loading = true;
        // ユーザ情報
        const patchPrifile = this.$authAxios.patch(
          "/api/userprofile",
          this.profile
        );

        // アンケート情報
        const postResponse = this.$authAxios
          .post("/api/responses/", {
            answers: this.responses,
            code_type: this.codeType
          })
          .then(response => {
            if (response.data.answers) {
              this.responses = response.data.answers;
            }
            if (response.data.response_date) {
              this.response_date = response.data.response_date;
            }
          })
          .catch(error => {
            throw error;
          });

        try {
          await Promise.all([patchPrifile, postResponse]);
          this.submitted = true;
        } catch (error) {
          console.error(error);
          this.error = true;
        } finally {
          this.loading = false;
        }
      } else {
        this.validateError = true;
      }
    },
    initializeResponses() {
      // responsesオブジェクトの初期化
      this.questions.forEach(question => {
        if (question.question_type === "checkbox") {
          this.$set(this.responses, question.id, []);
        } else {
          this.$set(this.responses, question.id, "");
        }
      });
    },
    isCheckboxQuestionIncomplete(questionId) {
      const selectedChoices = this.responses[questionId] || [];
      return selectedChoices.length === 0;
    },
    validateCheckboxQuestions() {
      for (const question of this.questions) {
        if (question.question_type === "checkbox") {
          const selectedChoices = this.responses[question.id] || [];
          if (selectedChoices.length === 0) {
            return false;
          }
        }
      }
      return true;
    },
    async validateForm() {
      let isValid = true;
      this.organizationError = "";
      this.referredByCodeError = "";
      this.organizationCodeError = "";
      this.lastNameError = "";
      this.firstNameError = "";

      this.filteredQuestions.forEach(question => {
        this.validateQuestion(question);
        if (question.errorMessage) isValid = false;
      });
      //組織コード入力時
      if (this.codeType === "org") {
        if (!this.profile.organization_code) {
          this.organizationCodeError = "入力してください。";
          isValid = false;
        } else {
          try {
            const res = await this.$authAxios.post("/api/check-org-code", {
              organization_code: this.profile.organization_code
            });
            if (!res.data.valid) {
              this.organizationCodeError =
                res.data.detail || "無効な組織コードです。";
              isValid = false;
            }
          } catch (error) {
            this.organizationCodeError =
              error.response.data.detail || "無効な組織コードです。";
            isValid = false;
          }
        }
      }

      if (this.codeType === "referral") {
        if (!this.profile.referred_by_code) {
          this.referredByCodeError = "入力してください。";
          isValid = false;
        } else {
          try {
            const res = await this.$authAxios.post(
              "/api/check-referred-by-code",
              {
                referred_by_code: this.profile.referred_by_code
              }
            );
            if (!res.data.valid) {
              this.referredByCodeError =
                res.data.detail || "無効な紹介者コードです。";
              isValid = false;
            }
          } catch (error) {
            this.referredByCodeError =
              error.response.data.detail || "無効な紹介者コードです。";
            isValid = false;
          }
        }
      }
      if (isValid) {
        return true;
      } else {
        return false;
      }
    },
    validateQuestion(question) {
      if (!question.required) return;
      if (this.codeType === "org" && question.is_org_info) return;

      question.errorMessage = "";

      if (
        question.question_type === "checkbox" &&
        this.responses[question.id].length === 0
      ) {
        question.errorMessage = `一つ以上選択してください。`;
      } else if (
        (question.question_type === "select" ||
          question.question_type === "radio") &&
        !this.responses[question.id]
      ) {
        question.errorMessage = `選択してください。`;
      } else if (!this.responses[question.id]) {
        question.errorMessage = `入力してください。`;
      }
    }
  },
  computed: {
    filteredQuestions() {
      if (this.codeType === "org") {
        // 組織コードあり → 組織情報系を除外
        return this.questions.filter(q => !q.is_org_info);
      }
      // none/referral → 全質問
      return this.questions;
    }
  },
  created() {
    this.$authAxios
      .get("/api/userprofile")
      .then(response => {
        this.profile = response.data;
      })
      .finally(() => {
        this.$authAxios
          .get(`/api/questions/`)
          .then(response => {
            this.questions = response.data.map(question => ({
              ...question,
              value: Array.isArray(question.value)
                ? [...question.value]
                : question.value,
              errorMessage: ""
            }));
          })
          .catch(error => {
            console.log(error);
          })
          .finally(() => {
            this.$authAxios.get("/api/responses/").then(response => {
              if (response.data.answers) {
                this.responses = response.data.answers;
              }
              if (response.data.response_date) {
                this.response_date = response.data.response_date;
                if (this.profile.organization_code) {
                  this.codeType = "org";
                } else if (this.profile.referred_by_code) {
                  this.codeType = "referral";
                } else {
                  this.codeType = "none";
                }
              } else {
                this.initializeResponses();
              }
            });
          });
      });
  }
};
</script>

<style scoped>
.survey-container {
  text-align: left;
  max-width: 600px;
  margin: 0 auto;
  padding: 20px;
  background-color: #f9f9f9;
  border: 1px solid #ddd;
  border-radius: 8px;
}

.survey-question {
  margin-bottom: 20px;
}

.question-text {
  font-weight: bold;
  margin-bottom: 8px;
}

.form-control {
  width: 100%;
  padding: 8px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.checkbox-options,
.radio-options {
  margin-top: 6px;
  margin-bottom: 6px;
}

.checkbox-label,
.radio-label {
  margin-left: 6px;
}

.btn {
  color: #fff;
  border: none;
  padding: 10px 20px;
  font-size: 16px;
  border-radius: 4px;
}

.btn-submit {
  background-color: #007bff;
  cursor: pointer;
}

.btn-disabled {
  background-color: grey;
}

.btn-submit:hover {
  background-color: #0056b3;
}

.error-message {
  color: red;
}

.required {
  color: red;
}
</style>
